import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import MetodoPago from './MetodoPago';
import ACCESS from '../../../ACCESS.js';

class MetodosPago extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'metodo-pago/filter', deleteUrl: 'metodo-pago/delete', deleteField: 'metodo_nombre', modUrl: '/Catalogo/MetodoPago' },
      TableOp.Table('Metodos de Pago', [
        { label: 'Clave', id: 'metodo' },
        { label: 'Descripcion', id: 'metodo_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_METODOS_DE_PAGO.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_METODOS_DE_PAGO.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <MetodoPago  onSave={() => {this.table()}}></MetodoPago>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(MetodosPago)